export const TRANSLATION_KEYS = {
  applicable: 'jbp-not-applicable-status-applicable',
  notApplicable: 'jbp-not-applicable-status-not-applicable',
}
